import React, { PropsWithChildren, useMemo } from "react";

type ContextProps = {
  facets: any
  product: any
  unlock: any
  earlyAccess: any
};

export const VipContext = React.createContext<ContextProps | undefined>(undefined);

export const VipProvider: React.FC<PropsWithChildren<{isCollection: boolean}>> = ({ children, isCollection }) => {
  const getJsonByQuery = (query: string) => {
    const script = document.querySelector(query)

    if (!script) return null

    try {
      const json = JSON.parse(script.innerHTML)
      return json
    } catch (e) {
      console.error("Error parsing locale JSON")
      return null
    }
  }

  const facets = useMemo(() => {
    return getJsonByQuery("[data-locale-facets]")
  }, [getJsonByQuery])

  const product = useMemo(() => {
    return getJsonByQuery("[data-locale-product]")
  }, [getJsonByQuery])

  const unlock = useMemo(() => {
    return isCollection ? getJsonByQuery("[data-locale-unlock]") : getJsonByQuery("[data-locale-unlock-page]")
  }, [getJsonByQuery, isCollection])

  const earlyAccess = useMemo(() => {
    return isCollection ? getJsonByQuery("[data-locale-eac]") : getJsonByQuery("[data-locale-eac-page]")
  }, [getJsonByQuery, isCollection])

  const contextValue = useMemo<ContextProps>(
    () => ({
      facets,
      product,
      unlock,
      earlyAccess
    }),
    [facets,product, unlock, earlyAccess]
  );

  return <VipContext.Provider value={contextValue}>{children}</VipContext.Provider>
};

export const useLocaleContext = (): ContextProps => ({ ...React.useContext(VipContext) } as ContextProps)